import { render, staticRenderFns } from "./CarBreadCrumbs.vue?vue&type=template&id=384dda1d"
import script from "./CarBreadCrumbs.vue?vue&type=script&lang=js"
export * from "./CarBreadCrumbs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports